import axiosInstance from "../../axiosInstance";
const BASE_URL = "/hrm/attendance";

export const getAllAttendanceLog = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/`, {
      params: {
        ...params,
        page: String(params.page || 1),
        size: String(params.size || 10),
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching attendance records:", error);
    throw error;
  }
};


// Thực hiện Checkin cho nhân viên
export const createAttendanceRecord = async (attendanceData) => {
    try {
        console.log("📤 Payload gửi đi khi chấm công:", attendanceData); // THÊM DÒNG NÀY
        const response = await axiosInstance.post(`${BASE_URL}/`, attendanceData);
        return response.data;
    } catch (error) {
        console.error("❌ Error creating attendance record:", error.response?.data || error.message);
        throw error;
    }
};

// Thực hiện checkout cho một bản ghi chấm công
export const checkoutAttendance = async (logId, location = null) => {
    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}/${logId}`, // ✅ Đúng route
        { check_out_location: location || "Không xác định" },
        { withCredentials: true }
      );
      return response.data;
    } catch (error) {
      console.error("Error during checkout:", error);
      throw error;
    }
  };
  


// Lấy thông tin chấm công có trạng thái "Checkin"
export const getActiveCheckins = async () => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/active-checkin`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching active checkins:", error);
      throw error;
    }
};
  

// Lấy giờ hệ thống từ BE (giờ lấy từ DB: SELECT NOW())
export const getServerTime = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/server-time`, {
      withCredentials: true,
    });
    return response.data; // { server_time, date, time }
  } catch (error) {
    console.error("Error fetching server time:", error);
    throw error;
  }
};


// Export FULL attendance logs (no pagination)
export const exportAttendanceLogs = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/export`,
      { params }
    );
    return response.data; // { records: [...], total: ... }
  } catch (error) {
    console.error("❌ Error exporting attendance logs:", error);
    throw error;
  }
};
  

export const updateAttendanceRecord = async (id, attendanceData) => {
    try {
        const response = await axiosInstance.put(`${BASE_URL}/attendance/${id}`, attendanceData);
        return response.data;
    } catch (error) {
        console.error("Error updating attendance record:", error);
        throw error;
    }
};

export const deleteAttendanceRecord = async (id) => {
    try {
        const response = await axiosInstance.delete(`${BASE_URL}/attendance/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting attendance record:", error);
        throw error;
    }
};


// Lấy trạng thái chấm công hiện tại
export const getAttendanceStatus = async () => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/status`
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching attendance status:", error);
    throw error;
  }
};
